import React, { useEffect, useState } from "react";
import { getMyAvailability, setAvailability, deleteAvailability } from "../api/availability";

const HOURS = ["08:00", "09:00", "10:00", "11:00", "12:00", "18:00", "19:00", "20:00", "21:00"];
const DAYS = [0, 1, 2, 3, 4, 5, 6]; // Lunes a Domingo

// Calcula el número de semana ISO
function getWeekNumber(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const weekNum = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  return weekNum;
}

// Devuelve objeto Date del día indicado de la semana ISO, en local time
function getDateOfISOWeek(week, year, day) {
  // ISO 8601: 0=Lunes
  const simple = new Date(year, 0, 1 + (week - 1) * 7);
  const dow = simple.getDay();
  const ISOweekStart = new Date(simple);
  if (dow <= 4) ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
  else ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
  ISOweekStart.setDate(ISOweekStart.getDate() + day);
  return ISOweekStart;
}

// Devuelve string YYYY-MM-DD en local time
function dateToLocalYYYYMMDD(dateObj) {
  const year = dateObj.getFullYear();
  const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
  const day = dateObj.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export default function AvailabilityCalendar({ token }) {
  const [selected, setSelected] = useState({});
  const [weekOffset, setWeekOffset] = useState(0);

  const now = new Date();
  const year = now.getFullYear();
  const currentWeek = getWeekNumber(now);
  const week = currentWeek + weekOffset;

  // Al cambiar de semana o usuario, carga disponibilidad
  useEffect(() => {
    getMyAvailability(token).then((slots) => {
      const sel = {};
      slots.forEach((slot) => {
        // slot.date puede ser "2025-07-22T00:00:00.000Z" o "2025-07-22"
        // Lo convertimos a local YYYY-MM-DD
        const d = new Date(slot.date);
        const dateStr = dateToLocalYYYYMMDD(d);
        const hour = slot.hour.slice(0, 5);
        sel[`${dateStr}_${hour}`] = true;
      });
      setSelected(sel);
    });
  }, [token, week]);

  // Marca/desmarca slot y guarda/cancela en BBDD
  function handleToggle(day, hour) {
    const d = getDateOfISOWeek(week, year, day);
    const isoDate = dateToLocalYYYYMMDD(d); // YYYY-MM-DD local
    const key = `${isoDate}_${hour}`;
    if (selected[key]) {
      deleteAvailability(token, isoDate, hour);
      setSelected((s) => ({ ...s, [key]: false }));
    } else {
      setAvailability(token, isoDate, hour);
      setSelected((s) => ({ ...s, [key]: true }));
    }
  }

  return (
    <div className="p-4 max-w-xl mx-auto">
      <h2 className="text-xl mb-4 text-lime-500">Mi disponibilidad</h2>
      <div className="flex justify-between gap-2 mb-2">
        <button className="btn px-2 py-1 bg-gray-500 text-white btn-sm" onClick={() => setWeekOffset((w) => w - 1)}>
          Sem. anterior
        </button>
        <span className="text-emerald-500">Semana {week}</span>
        <button className="btn px-2 py-1 bg-gray-500 text-white btn-sm" onClick={() => setWeekOffset((w) => w + 1)}>
          Sem. siguiente
        </button>
      </div>
      <table className="table w-full border">
        <thead>
          <tr>
            <th>Hora</th>
            {DAYS.map((day) => {
              const d = getDateOfISOWeek(week, year, day);
              const dia = d.toLocaleDateString("es-ES", { weekday: "short" }).charAt(0).toUpperCase();
              const fecha = d.getDate();
              const mes = d.toLocaleDateString("es-ES", { month: "short" }).replace(".", "");
              return (
                <th key={day} className="text-center">
                  {`${dia}-${fecha} ${mes}`}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {HOURS.map((hour) => (
            <tr key={hour}>
              <td className="font-bold">{hour}</td>
              {DAYS.map((day) => {
                const d = getDateOfISOWeek(week, year, day);
                const isoDate = dateToLocalYYYYMMDD(d);
                const key = `${isoDate}_${hour}`;
                return (
                  <td key={day} className="text-center">
                    <button type="button" className={`w-8 h-8 rounded-full ${selected[key] ? "bg-green-500" : "bg-gray-200"}`} onClick={() => handleToggle(day, hour)}>
                      {selected[key] ? "✔️" : ""}
                    </button>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

